type SkeletonVariant = "heading" | "line" | "line-short" | "block";

interface SkeletonProps {
  variant: SkeletonVariant;
  className?: string;
}

const variantClasses: Record<SkeletonVariant, string> = {
  heading:    "h-6 w-3/4 rounded",
  line:       "h-4 w-full rounded",
  "line-short": "h-4 w-2/3 rounded",
  block:      "h-32 w-full rounded",
};

export function Skeleton({ variant, className = "" }: SkeletonProps) {
  return (
    <div
      className={`animate-pulse bg-slate-200 dark:bg-slate-700 ${variantClasses[variant]} ${className}`}
      aria-hidden="true"
    />
  );
}

/** Pre-composed document skeleton: 1 heading + 4 lines + 1 short line, repeated twice. */
export function DocumentSkeleton({ className = "" }: { className?: string }) {
  return (
    <div
      className={`space-y-3 ${className}`}
      data-testid="document-skeleton"
      aria-label="Loading document…"
      aria-busy="true"
    >
      {[0, 1].map((block) => (
        <div key={block} className="space-y-2">
          <Skeleton variant="heading" />
          <Skeleton variant="line" />
          <Skeleton variant="line" />
          <Skeleton variant="line" />
          <Skeleton variant="line" />
          <Skeleton variant="line-short" />
        </div>
      ))}
    </div>
  );
}
